/* unplugin-vue-components disabled */import { render } from "./infoList.vue?vue&type=template&id=2bbd2626&scoped=true"
import script from "./infoList.vue?vue&type=script&lang=js"
export * from "./infoList.vue?vue&type=script&lang=js"

import "./infoList.vue?vue&type=style&index=0&id=2bbd2626&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbd2626"]])

export default __exports__